import dayjs from 'dayjs';

const DateService = {
    stringToDate: (str?: string | null): Date | null => {
        return str ? dayjs(str, 'YYYY-MM-DD').toDate() : null;
    },

    dateToString: (date?: Date | null): string => {
        if (!date) {
            return '';
        }
        const dateWithoutOffset = new Date(date.getTime() - date.getTimezoneOffset() * 60000 + 60000);
        return dateWithoutOffset.toISOString().split('T')[0];
    },

    getAge: (str?: string): number => {
        return dayjs().diff(str, 'years');
    },

    isOver18: (str?: string): boolean => {
        return DateService.getAge(str) >= 18;
    },

    formatUserInput: (event: any) => {
        const target = event.target as HTMLInputElement;
        let value = target.value;
        if (!value) {
            return;
        }

        // Leave only digits and slashes.
        value = value.replaceAll(/[^0-9/]+/g, '');

        // Remove double slashes.
        while (value.indexOf('//') > -1) {
            value = value.replace('//', '/');
        }

        if (value.length === 3 && value.indexOf('/') === -1) {
            // 111 -> 11/1
            value = value.substring(0, 2) + '/' + value.substring(2);
        } else if (
            value.length === 5 &&
            value.substring(1, 2) === '/' &&
            value.substring(3, 4) !== '/' &&
            value.substring(4, 5) !== '/'
        ) {
            // 1/111 -> 1/11/1
            value = value.substring(0, 4) + '/' + value.substring(4);
        } else if (
            value.length === 6 &&
            value.substring(2, 3) === '/' &&
            value.substring(4, 5) !== '/' &&
            value.substring(5, 6) !== '/'
        ) {
            // 11/111 -> 11/11/1
            value = value.substring(0, 5) + '/' + value.substring(5);
        }

        // Limit the length.
        const parts = value.split('/');
        if (parts.length === 3 && parts[2].length > 4) {
            value = parts[0] + '/' + parts[1] + '/' + parts[2].substring(0, 4);
        }

        target.value = value;
    },
};

export default DateService;
